import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect /* useState */, useState } from "react";
import {
  AppButton,
  AppTable,
  FormInput,
  AppModal /* SubAdminComponent */,
  FormSelect,
  SearchInput,
} from "components";
import { TableBodyContent } from "components/AppTable";
import { Router } from "utils/route";
import { ApiService } from "services";
import { toast } from "react-hot-toast";
import { checked, warning } from "assets/icons";
import { userData } from "utils/userData";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import Skeleton2 from "components/Skeleton2";
//import styled from "styled-components";
//import { add } from "assets/icons";

export default function SubAdmins({ title }) {
  const [step, setStep] = useState(0);
  const [step2, setStep2] = useState(0);
  const [step3, setStep3] = useState(0);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);

  const [item, setItem] = useState(false);

  const [loading, setLoading] = useState(false);

  const [firstName, setFirsName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [phoneNo, setPhoneNo] = useState();
  const [code, setCode] = useState();
  const [roleType, setRoleType] = useState();
  const [metrics, setMetrics] = useState([]);

  const [searchInput, setSearchInput] = useState("");

  const [admins, setAdmins] = useState([]);

  console.log(admins);
  const savedItems = JSON.parse(localStorage.getItem("sInst2"));

  const createAdmin = async () => {
    setLoading(true);
    try {
      const data = await ApiService.createAdmin(
        (roleType === "subAdmin1" && {
          firstName: firstName || savedItems.firstName,
          lastName: lastName || savedItems.lastName,
          email: email || savedItems?.email,
          phoneNo: phoneNo || savedItems?.phoneNo,
          role: roleType || savedItems?.role,
          metrics: metrics || savedItems?.metrics,
        }) ||
          (roleType === "subAdmin2" && {
            firstName: firstName || savedItems.firstName,
            lastName: lastName || savedItems.lastName,
            email: email || savedItems?.email,
            phoneNo: phoneNo || savedItems?.phoneNo,
            role: roleType || savedItems?.role,
            metrics: metrics || savedItems?.metrics,
          }) || {
            firstName: firstName || savedItems?.firstName,
            lastName: lastName || savedItems?.lastName,
            email: email || savedItems?.email,
            phoneNo: phoneNo || savedItems?.phoneNo,
            role: roleType || savedItems?.roleType,
            institutionId: userData?.userDetail?.institution?.code
              ? `${userData?.userDetail?.institution?.code}`
              : `${code || savedItems?.code}`,
            metrics: metrics || savedItems?.metrics,
          }
      );
      setStep(2);
      setLoading(false);
      localStorage.removeItem("sInst2");
      if (
        userData?.userDetail?.role === "chiefAdmin" ||
        userData?.userDetail?.role === "subAdmin1" ||
        userData?.userDetail?.role === "subAdmin2"
      ) {
        route(`/sub-admins?tab=${roleType}`);
      }
      if (userData?.userDetail?.role === "bankAdmin") {
        route(`/bank-user?tab=${roleType}`);
      }
      if (userData?.userDetail?.role === "nonBankAdmin") {
        route(`/non-bank-user?tab=${roleType}`);
      }
      console.log(data);
    } catch (err) {
      console.log(err?.message);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const editAdmin = async () => {
    setLoading(true);
    try {
      const data = await ApiService.editAdmin(item?.id, {
        phoneNumber:
          phoneNo || item?.userDetail?.phoneNumber || item?.phoneNumber,
        role: roleType || item?.userDetail?.role || item?.role,
        metric: metrics || item?.userDetail?.metrics || item?.metrics,
      });
      setStep3(2);
      setLoading(false);
      getAdmins(`?adminType=${activeTab}`);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const [id, setId] = useState();
  const deleteAdmin = async () => {
    setLoading(true);
    try {
      const data = await ApiService.deleteAdmin(id);
      setStep2(1);
      setLoading(false);

      console.log(data);
    } catch (err) {
      console.log(err?.message);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getAdmins = async (id) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2" ||
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "nonBankAdmin"
    ) {
      setLoading(true);
      try {
        const data = await ApiService.getAdmins(id);
        console.log(data);
        setAdmins(data?.data);
        setLoading(false);

        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const removeItem = (name) => {
    setMetrics((current) => current.filter((item) => item !== name));
  };

  function handleCheck(val) {
    return metrics.some((item) => val === item);
  }

  const subAdminTabs =
    (userData?.userDetail?.role === "chiefAdmin" && [
      /*  {
        title: "Chief Admin",
        param: "chiefAdmin",
        route: "/sub-admins?tab=chiefAdmin",
      }, */
      {
        title: "Sub Admin 1",
        param: "subAdmin1",
        route: "/sub-admins?tab=subAdmin1",
      },
      {
        title: "Sub Admin 2",
        param: "subAdmin2",
        route: "/sub-admins?tab=subAdmin2",
      },
      {
        title: "Bank Admin",
        param: "bankAdmin",
        route: "/sub-admins?tab=bankAdmin",
      },
      {
        title: "Non Bank Admin",
        param: "nonBankAdmin",
        route: "/sub-admins?tab=nonBankAdmin",
      },
      {
        title: "Bank User 1",
        param: "bankUser1",
        route: "/sub-admins?tab=bankUser1",
      },
      {
        title: "Non Bank User 1",
        param: "nonBankUser1",
        route: "/sub-admins?tab=nonBankUser1",
      },
      {
        title: "Bank User 2",
        param: "bankUser2",
        route: "/sub-admins?tab=bankUser2",
      },
      {
        title: "Non Bank User 2",
        param: "nonBankUser2",
        route: "/sub-admins?tab=nonBankUser2",
      },
    ]) ||
    (userData?.userDetail?.role === "subAdmin1" && [
      {
        title: "Sub Admin 1",
        param: "subAdmin1",
        route: "/sub-admins?tab=subAdmin1",
      },
      {
        title: "Sub Admin 2",
        param: "subAdmin2",
        route: "/sub-admins?tab=subAdmin2",
      },
      {
        title: "Bank Admin",
        param: "bankAdmin",
        route: "/sub-admins?tab=bankAdmin",
      },
      {
        title: "Non Bank Admin",
        param: "nonBankAdmin",
        route: "/sub-admins?tab=nonBankAdmin",
      },
    ]) ||
    (userData?.userDetail?.role === "subAdmin2" && [
      {
        title: "Sub Admin 1",
        param: "subAdmin1",
        route: "/sub-admins?tab=subAdmin1",
      },
      {
        title: "Sub Admin 2",
        param: "subAdmin2",
        route: "/sub-admins?tab=subAdmin2",
      },
      {
        title: "Bank Admin",
        param: "bankAdmin",
        route: "/sub-admins?tab=bankAdmin",
      },
      {
        title: "Non Bank Admin",
        param: "nonBankAdmin",
        route: "/sub-admins?tab=nonBankAdmin",
      },
    ]) ||
    (userData?.userDetail?.role === "bankAdmin" && [
      {
        title: "Bank User 1",
        param: "bankUser1",
        route: "/bank-user?tab=bankUser1",
      },
      {
        title: "Bank User 2",
        param: "bankUser2",
        route: "/bank-user?tab=bankUser2",
      },
    ]) ||
    (userData?.userDetail?.role === "nonBankAdmin" && [
      {
        title: "Non Bank User 1",
        param: "nonBankUser1",
        route: "/non-bank-user?tab=nonBankUser1",
      },
      {
        title: "Non Bank User 2",
        param: "nonBankUser2",
        route: "/non-bank-user?tab=nonBankUser2",
      },
    ]);
  const { route } = Router();
  const [param] = useSearchParams();
  const activeTab = param.get("tab");
  useEffect(() => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      route(`/sub-admins?tab=${subAdminTabs[0].param}`);
      getAdmins(`?adminType=${activeTab}`);
    }
    if (userData?.userDetail?.role === "bankAdmin") {
      route(`/bank-user?tab=${subAdminTabs[0].param}`);
      getAdmins(`?adminType=${activeTab}`);
    }
    if (userData?.userDetail?.role === "nonBankAdmin") {
      route(`/non-bank-user?tab=${subAdminTabs[0].param}`);
      getAdmins(`?adminType=${activeTab}`);
    }
    //eslint-disable-next-line
  }, []);

  console.log("userData", metrics);

  // const [showDetails, setShowDetails] = useState(false);
  useEffect(() => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2" ||
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "nonBankAdmin"
    ) {
      getAdmins(`?adminType=${activeTab}`);
      setAdmins([]);
    }
  }, [activeTab]);

  return (
    <DashboardLayout>
      <AppTable
        tableHeadLength="10"
        btnTitle={
          (userData?.userDetail?.role === "chiefAdmin" &&
            "New Administrator") ||
          (userData?.userDetail?.role === "subAdmin1" && "New Administrator") ||
          (userData?.userDetail?.role === "subAdmin2" && "New Administrator") ||
          (userData?.userDetail?.role === "bankAdmin" && "New Bank User") ||
          (userData?.userDetail?.role === "nonBankAdmin" && "New Non Bank User")
        }
        btnAction={() => {
          setModal(true);
          setCode("");
          setEmail("");
          setEmail("");
          setFirsName("");
          setLastName("");
          setMetrics(savedItems?.metrics || []);
          setPhoneNo("");
          setStep(0);
        }}
        tableHead={[
          "FIRSTNAME",
          "LASTNAME",
          "ID",
          "INSTITUTION",
          "EMAIL ADDRESS",
          "PHONE NUMBER",
          "DATE CREATED",
          "Password Changed",
          "action",
        ]}
        titleB={
          (userData?.userDetail?.role === "chiefAdmin" &&
            "Administrators and Users") ||
          (userData?.userDetail?.role === "subAdmin1" && "Administrators") ||
          (userData?.userDetail?.role === "subAdmin2" && "Administrators") ||
          (userData?.userDetail?.role === "bankAdmin" && "Bank Users") ||
          (userData?.userDetail?.role === "nonBankAdmin" && "Non Bank Users")
        }
        tabs={subAdminTabs}
        loading={loading}
        columnWidth="150px"
        param2={`adminType=${activeTab}`}
        action={getAdmins}
        transactions={admins}
        searchInput={searchInput}
        pagination={
          (userData?.userDetail?.role === "bankAdmin" && false) ||
          (userData?.userDetail?.role === "nonBankAdmin" && false) ||
          (userData?.userDetail?.role === "bankUser1" && false) ||
          (userData?.userDetail?.role === "bankUser2" && false) ||
          (userData?.userDetail?.role === "nonBankUser1" && false) ||
          (userData?.userDetail?.role === "nonBankUser2" && false) ||
          (userData?.userDetail?.role === "chiefAdmin" && true) ||
          (userData?.userDetail?.role === "subAdmin1" && true) ||
          (userData?.userDetail?.role === "subAdmin2" && true)
        }
        childrenHead={
          <div>
            <SearchInput
              width="160%"
              onChange={(e) => {
                getAdmins(
                  `?search=${e.target.value || ""}&adminType=${activeTab}`
                );
                setSearchInput(e.target.value);
              }}
            />
          </div>
        }
      >
        <TableBodyContent>
          {loading ? (
            <div style={{ width: "80vw" }}>
              <Skeleton2 height="500px" />
            </div>
          ) : (
            admins?.results?.map((item) => {
              return (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(10, 150px)`,
                  }}
                  className="table_body_item"
                >
                  <div>{item?.firstName}</div>
                  <div>{item?.lastName}</div>
                  <div>{item?.id}</div>
                  <div>{item?.userDetail?.institution?.name || "UP"}</div>
                  <div className="email">
                    {item?.email?.slice(0, 10)}...{" "}
                    <span style={{ position: "absolute" }}>{item?.email}</span>{" "}
                  </div>
                  <div>{item?.userDetail?.phoneNumber}</div>
                  <div>
                    {moment(item?.dateJoined)
                      .subtract(1, "hours")
                      .format("DD-MM-YYYY hh:mm")}
                  </div>
                  <div
                    style={{
                      backgroundColor:
                        item?.userDetail?.passwordChanged !== true
                          ? "#fF00111A"
                          : "#01A9261A",
                      color:
                        item?.userDetail?.passwordChanged !== true
                          ? "#FF0011CC"
                          : "#01A926",
                      padding: "8px",
                      borderRadius: "5px",
                      width: "40%",
                      textAlign: "center",
                    }}
                  >
                    {item?.userDetail?.passwordChanged === true
                      ? "True"
                      : "False"}
                  </div>
                  <div
                    onClick={() => {
                      setModal2(true);
                      setId(item?.id);
                    }}
                    style={{
                      borderRadius: "5px",
                      width: "fit-content",
                      cursor: "pointer",
                      display: "grid",
                      placeItems: "center",
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_302_2)">
                        <path
                          d="M12.6415 1.91693H10.151C10.0267 0.839618 9.11012 0 8 0C6.88992 0 5.97346 0.839585 5.84922 1.91693H3.35855C2.35065 1.91693 1.53076 2.73705 1.53076 3.74492V3.83871C1.53076 4.60891 2.01034 5.26814 2.68592 5.53675V14.172C2.68592 15.1799 3.5059 16 4.51374 16H11.4863C12.4942 16 13.3141 15.1799 13.3141 14.172V5.53678C13.9897 5.26814 14.4693 4.60891 14.4693 3.83874V3.74495C14.4693 2.73705 13.6493 1.91693 12.6415 1.91693ZM8 0.866913C8.63138 0.866913 9.15838 1.31946 9.27499 1.91693H6.72525C6.84183 1.31942 7.36886 0.866913 8 0.866913ZM12.4472 14.172C12.4472 14.7019 12.0161 15.1331 11.4863 15.1331H4.51371C3.98395 15.1331 3.5528 14.7019 3.5528 14.172V5.66669H12.4472V14.172ZM13.6024 3.83871C13.6024 4.36863 13.1712 4.79981 12.6415 4.79981H3.35855C2.8288 4.79981 2.39764 4.36863 2.39764 3.83871V3.74492C2.39764 3.215 2.8288 2.78381 3.35855 2.78381H12.6415C13.1712 2.78381 13.6024 3.215 13.6024 3.74492L13.6024 3.83871Z"
                          fill="#FF0000"
                          stroke="#FF0000"
                        />
                        <path
                          d="M5.67612 14.0245C5.91551 14.0245 6.10956 13.8304 6.10956 13.5911V8.71063C6.10956 8.47131 5.91547 8.27716 5.67612 8.27716C5.43676 8.27716 5.24268 8.47131 5.24268 8.71063V13.5911C5.24264 13.8304 5.43673 14.0245 5.67612 14.0245Z"
                          fill="#FF0000"
                          stroke="#FF0000"
                        />
                        <path
                          d="M7.99985 14.0245C8.23924 14.0245 8.43332 13.8304 8.43332 13.5911V8.71063C8.43332 8.47131 8.23917 8.27716 7.99985 8.27716C7.76049 8.27716 7.56641 8.47131 7.56641 8.71063V13.5911C7.56641 13.8304 7.76046 14.0245 7.99985 14.0245Z"
                          fill="#FF0000"
                          stroke="#FF0000"
                        />
                        <path
                          d="M10.3241 14.0245C10.5635 14.0245 10.7575 13.8304 10.7575 13.5911V8.71063C10.7575 8.47131 10.5634 8.27716 10.3241 8.27716C10.0847 8.27716 9.89063 8.47131 9.89063 8.71063V13.5911C9.89059 13.8304 10.0847 14.0245 10.3241 14.0245Z"
                          fill="#FF0000"
                          stroke="#FF0000"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_302_2">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <div
                    onClick={() => {
                      setModal3(true);
                      setItem(item);
                      setMetrics(
                        item?.userDetail?.metrics || item?.metrics || []
                      );
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      style={{ width: "20px" }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      id="edit"
                    >
                      <path d="M5,18H9.24a1,1,0,0,0,.71-.29l6.92-6.93h0L19.71,8a1,1,0,0,0,0-1.42L15.47,2.29a1,1,0,0,0-1.42,0L11.23,5.12h0L4.29,12.05a1,1,0,0,0-.29.71V17A1,1,0,0,0,5,18ZM14.76,4.41l2.83,2.83L16.17,8.66,13.34,5.83ZM6,13.17l5.93-5.93,2.83,2.83L8.83,16H6ZM21,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"></path>
                    </svg>
                  </div>
                </div>
              );
            })
          )}
        </TableBodyContent>
      </AppTable>

      {modal && (
        <div>
          {step === 0 && (
            <AppModal
              closeModal={() => {
                setMetrics([]);
                setModal(false);
                setCode("");
                setEmail("");
                setEmail("");
                setFirsName("");
                setLastName("");
                setPhoneNo("");
              }}
              heading="Add New Administrator"
            >
              <FormInput
                label="Administrator First Name *"
                placeholder="Enter the Administrator Name"
                onChange={(e) => {
                  setFirsName(e.target.value);
                }}
                defaultValue={savedItems?.firstName}
              />
              <FormInput
                label="Administrator Last Name *"
                placeholder="Enter the Administrator Name"
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
                defaultValue={savedItems?.lastName}
              />
              <FormInput
                label="Administrator Email *"
                placeholder="Enter the Administrator Name"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                defaultValue={savedItems?.email}
              />

              <FormInput
                label="Administrator Phone Number *"
                placeholder="Enter the Administrator Name"
                onChange={(e) => {
                  setPhoneNo(e.target.value);
                }}
                defaultValue={savedItems?.phoneNo}
              />

              <FormSelect
                label="Select Level/Role*"
                placeholder="Select Role"
                defaultValue={savedItems?.roleType}
                options={
                  (userData?.userDetail?.role === "chiefAdmin" && [
                    { name: "Sub Admin 1", value: "subAdmin1" },
                    { name: "Sub Admin 2", value: "subAdmin2" },
                    {
                      name: "Bank Admin",
                      value: "bankAdmin",
                    },
                    {
                      name: "Non Bank Admin",
                      value: "nonBankAdmin",
                    },
                  ]) ||
                  (userData?.userDetail?.role === "subAdmin1" && [
                    { name: "Sub Admin 1", value: "subAdmin1" },
                    { name: "Sub Admin 2", value: "subAdmin2" },
                    {
                      name: "Bank Admin",
                      value: "bankAdmin",
                    },
                    {
                      name: "Non Bank Admin",
                      value: "nonBankAdmin",
                    },
                  ]) ||
                  (userData?.userDetail?.role === "subAdmin2" && [
                    { name: "Sub Admin 1", value: "subAdmin1" },
                    { name: "Sub Admin 2", value: "subAdmin2" },
                    {
                      name: "Bank Admin",
                      value: "bankAdmin",
                    },
                    {
                      name: "Non Bank Admin",
                      value: "nonBankAdmin",
                    },
                  ]) ||
                  (userData?.userDetail?.role === "bankAdmin" && [
                    { name: "Bank User 1", value: "bankUser1" },
                    { name: "Bank User 2", value: "bankUser2" },
                  ]) ||
                  (userData?.userDetail?.role === "nonBankAdmin" && [
                    { name: "Non Bank User 1", value: "nonBankUser1" },
                    { name: "Non Bank User 2", value: "nonBankUser2" },
                  ])
                }
                optionLabel="name"
                optionValue="value"
                onChange={(e) => {
                  setRoleType(e.target.value);
                }}
              />
              {!userData?.userDetail?.institution?.code && (
                <>
                  {roleType === "subAdmin1" || roleType === "subAdmin2" ? (
                    ""
                  ) : (
                    <FormInput
                      label="Administrator Institution Code*"
                      placeholder="Enter the Administrator Institution Code"
                      type="number"
                      defaultValue={savedItems?.code}
                      onChange={(e) => {
                        setCode(e.target.value);
                      }}
                    />
                  )}
                </>
              )}
              <FormSelect
                label="Select Metrics Access For Admin*"
                placeholder="Select Metrics"
                options={[
                  {
                    name: "Institution Performance",
                    value: "institutionPerformance",
                  },
                  {
                    name: "Site Performance",
                    value: "sitePerformance",
                  },
                  {
                    name: "Transaction Report",
                    value: "transactionReport",
                  },
                  {
                    name: "Transaction Performance",
                    value: "transactionPerformance",
                  },
                  {
                    name: "Transaction Count Amount",
                    value: "transactionCountAmount",
                  },
                  {
                    name: "Today's Transaction",
                    value: "todayTransaction",
                  },
                  {
                    name: "Institution Admin Count",
                    value: "institutionUserAdminCount",
                  },
                ]}
                optionLabel="name"
                optionValue="value"
                onChange={(e) => {
                  if (handleCheck(e.target.value)) {
                    toast.error("Metrics already selected");
                  } else {
                    setMetrics([...metrics, e.target.value]);
                  }
                }}
              />

              <ListedMetrics>
                {metrics?.map((item) => {
                  return (
                    <div
                      onClick={(e) => {
                        removeItem(item);
                      }}
                      className="list"
                    >
                      {item}
                    </div>
                  );
                })}
              </ListedMetrics>

              <AppButton
                onClick={() => {
                  if (
                    firstName &&
                    lastName &&
                    email &&
                    phoneNo &&
                    roleType &&
                    metrics?.length
                  ) {
                    setStep(1);
                    localStorage.setItem(
                      "sInst2",
                      JSON.stringify({
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phoneNo: phoneNo,
                        roleType: roleType,
                        metrics: metrics,
                        code: code,
                      })
                    );
                  } else {
                    if (savedItems) {
                      localStorage.setItem(
                        "sInst2",
                        JSON.stringify({
                          firstName: savedItems?.firstName,
                          lastName: savedItems?.lastName,
                          email: savedItems?.email,
                          phoneNo: savedItems?.phoneNo,
                          roleType: savedItems?.roleType,
                          metrics: savedItems?.metrics,
                          code: savedItems?.code,
                        })
                      );
                      setStep(1);
                    } else {
                      toast.error("Some field(s) are empty.");
                    }
                  }
                }}
                placeholder="Proceed"
              />
            </AppModal>
          )}
          {step === 1 && (
            <AppModal
              closeModal={() => {
                setModal(false);
                setCode("");
                setEmail("");
                setEmail("");
                setFirsName("");
                setLastName("");
                setMetrics([]);
                setPhoneNo("");
                setStep(0);
              }}
            >
              <div>
                <img src={warning} alt="" />
                <h3>Confirm Changes</h3>
              </div>
              <p style={{ margin: "30px 0" }}>
                Are you sure you want to add this admin?
              </p>
              <div style={{ display: "flex" }}>
                <AppButton
                  onClick={() => {
                    setCode("");
                    setEmail("");
                    setEmail("");
                    setFirsName("");
                    setLastName("");
                    //setMetrics([]);
                    setPhoneNo("");
                    setStep(0);
                  }}
                  outline
                  placeholder="Cancel"
                />
                &nbsp; &nbsp; &nbsp; &nbsp;
                <AppButton
                  onClick={() => {
                    createAdmin();
                  }}
                  placeholder="Confirm"
                  loading={loading}
                  disabled={loading}
                />
              </div>
            </AppModal>
          )}
          {step === 2 && (
            <AppModal
              closeModal={() => {
                setModal(false);
                setCode("");
                setEmail("");
                setEmail("");
                setFirsName("");
                setLastName("");
                setMetrics([]);
                setPhoneNo("");
                setStep(0);
              }}
            >
              <div>
                <img src={checked} alt="" />
                <h3>Changes saved</h3>
              </div>
              <p style={{ margin: "30px 0" }}>
                Admin has been successfully added.
              </p>
            </AppModal>
          )}
        </div>
      )}
      {modal2 && (
        <div>
          {step2 === 0 && (
            <AppModal
              closeModal={() => {
                setModal2(false);
                setCode("");
                setEmail("");
                setEmail("");
                setFirsName("");
                setLastName("");
                setMetrics([]);
                setPhoneNo("");
                setStep2(0);
              }}
            >
              <div>
                <img src={warning} alt="" />
                <h3>Confirm Changes</h3>
              </div>
              <p style={{ margin: "30px 0" }}>
                Are you sure you want to delete this admin?
              </p>
              <div style={{ display: "flex" }}>
                <AppButton
                  onClick={() => {
                    setModal2(false);
                    setCode("");
                    setEmail("");
                    setEmail("");
                    setFirsName("");
                    setLastName("");
                    setMetrics([]);
                    setPhoneNo("");
                    setStep(0);
                  }}
                  outline
                  placeholder="Cancel"
                />
                &nbsp; &nbsp; &nbsp; &nbsp;
                <AppButton
                  onClick={() => {
                    deleteAdmin();
                  }}
                  placeholder="Confirm"
                  loading={loading}
                  disabled={loading}
                />
              </div>
            </AppModal>
          )}
          {step2 === 1 && (
            <AppModal
              closeModal={() => {
                setModal2(false);
                setCode("");
                setEmail("");
                setEmail("");
                setFirsName("");
                setLastName("");
                setMetrics([]);
                setPhoneNo("");
                setStep2(0);
              }}
            >
              <div>
                <img src={checked} alt="" />
                <h3>Changes saved</h3>
              </div>
              <p style={{ margin: "30px 0" }}>
                Admin has been successfully deleted.
              </p>
            </AppModal>
          )}
        </div>
      )}

      {modal3 && (
        <div>
          {step3 === 0 && (
            <AppModal
              closeModal={() => {
                setModal3(false);
                setCode("");
                setEmail("");
                setEmail("");
                setFirsName("");
                setLastName("");
                setPhoneNo("");
                setMetrics([]);
                console.log(modal3);
              }}
              heading={`Edit ${item?.firstName + " " + item?.lastName}`}
            >
              <FormInput
                label="Administrator First Name *"
                placeholder="Enter the Administrator Name"
                onChange={(e) => {
                  setFirsName(e.target.value);
                }}
                defaultValue={item?.firstName}
                disabled
              />
              <FormInput
                label="Administrator Last Name *"
                placeholder="Enter the Administrator Name"
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
                defaultValue={item?.lastName}
                disabled
              />
              <FormInput
                label="Administrator Email *"
                placeholder="Enter the Administrator Email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                defaultValue={item?.email}
                disabled
              />

              <FormInput
                label="Administrator Phone Number *"
                placeholder="Enter the Administrator Phone Number"
                onChange={(e) => {
                  setPhoneNo(e.target.value);
                }}
                defaultValue={
                  item?.userDetail?.phoneNumber || item?.phoneNumber
                }
              />

              <FormSelect
                label="Select Level/Role*"
                placeholder="Select Role"
                options={
                  (userData?.userDetail?.role === "chiefAdmin" && [
                    { name: "Sub Admin 1", value: "subAdmin1" },
                    { name: "Sub Admin 2", value: "subAdmin2" },
                    {
                      name: "Bank Admin",
                      value: "bankAdmin",
                    },
                    {
                      name: "Non Bank Admin",
                      value: "nonBankAdmin",
                    },
                    { name: "Bank User 1", value: "bankUser1" },
                    { name: "Bank User 2", value: "bankUser2" },
                    { name: "Non Bank User 1", value: "nonBankUser1" },
                    { name: "Non Bank User 2", value: "nonBankUser2" },
                  ]) ||
                  (userData?.userDetail?.role === "subAdmin1" && [
                    { name: "Sub Admin 1", value: "subAdmin1" },
                    { name: "Sub Admin 2", value: "subAdmin2" },
                    {
                      name: "Bank Admin",
                      value: "bankAdmin",
                    },
                    {
                      name: "Non Bank Admin",
                      value: "nonBankAdmin",
                    },
                  ]) ||
                  (userData?.userDetail?.role === "subAdmin2" && [
                    { name: "Sub Admin 1", value: "subAdmin1" },
                    { name: "Sub Admin 2", value: "subAdmin2" },
                    {
                      name: "Bank Admin",
                      value: "bankAdmin",
                    },
                    {
                      name: "Non Bank Admin",
                      value: "nonBankAdmin",
                    },
                  ]) ||
                  (userData?.userDetail?.role === "bankAdmin" && [
                    { name: "Bank User 1", value: "bankUser1" },
                    { name: "Bank User 2", value: "bankUser2" },
                  ]) ||
                  (userData?.userDetail?.role === "nonBankAdmin" && [
                    { name: "Non Bank User 1", value: "nonBankUser1" },
                    { name: "Non Bank User 2", value: "nonBankUser2" },
                  ])
                }
                value={item?.userDetail?.role}
                optionLabel="name"
                optionValue="value"
                onChange={(e) => {
                  setRoleType(e.target.value);
                }}
              />
              {!userData?.userDetail?.institution?.code && (
                <>
                  {roleType === "subAdmin1" || roleType === "subAdmin2" ? (
                    ""
                  ) : (
                    <FormInput
                      label="Administrator Institution Code*"
                      placeholder="Enter the Administrator Institution Code"
                      type="number"
                      onChange={(e) => {
                        setCode(e.target.value);
                      }}
                      defaultValue={item?.userDetail?.institution?.code}
                      disabled
                    />
                  )}
                </>
              )}
              <FormSelect
                label="Select Metrics Access For Admin*"
                placeholder="Select Metrics"
                options={[
                  {
                    name: "Institution Performance",
                    value: "institutionPerformance",
                  },
                  {
                    name: "Site Performance",
                    value: "sitePerformance",
                  },
                  {
                    name: "Transaction Report",
                    value: "transactionReport",
                  },
                  {
                    name: "Transaction Performance",
                    value: "transactionPerformance",
                  },
                  {
                    name: "Transaction Count Amount",
                    value: "transactionCountAmount",
                  },
                  {
                    name: "Today's Transaction",
                    value: "todayTransaction",
                  },
                  {
                    name: "Institution Admin Count",
                    value: "institutionUserAdminCount",
                  },
                ]}
                optionLabel="name"
                optionValue="value"
                onChange={(e) => {
                  if (handleCheck(e.target.value)) {
                    toast.error("Metrics already selected");
                  } else {
                    setMetrics([...metrics, e.target.value]);
                  }
                }}
              />

              <ListedMetrics>
                {metrics?.map((item) => {
                  return (
                    <span
                      onClick={(e) => {
                        removeItem(item);
                      }}
                      className="list"
                    >
                      {item}
                    </span>
                  );
                })}
              </ListedMetrics>

              <AppButton
                onClick={() => {
                  setStep3(1);
                }}
                placeholder="Proceed"
              />
            </AppModal>
          )}
          {step3 === 1 && (
            <AppModal
              closeModal={() => {
                setModal3(false);
                setCode("");
                setEmail("");
                setEmail("");
                setFirsName("");
                setLastName("");
                setMetrics([]);
                setPhoneNo("");
                setStep3(0);
              }}
            >
              <div>
                <img src={warning} alt="" />
                <h3>Confirm Changes</h3>
              </div>
              <p style={{ margin: "30px 0" }}>
                Are you sure you want to edit this admin?
              </p>
              <div style={{ display: "flex" }}>
                <AppButton
                  onClick={() => {
                    setCode("");
                    setEmail("");
                    setEmail("");
                    setFirsName("");
                    setModal3(false);
                    setLastName("");
                    setMetrics([]);
                    setPhoneNo("");
                    setStep3(0);
                  }}
                  outline
                  placeholder="Cancel"
                />
                &nbsp; &nbsp; &nbsp; &nbsp;
                <AppButton
                  onClick={() => {
                    editAdmin();
                  }}
                  placeholder="Confirm"
                  loading={loading}
                  disabled={loading}
                />
              </div>
            </AppModal>
          )}
          {step3 === 2 && (
            <AppModal
              closeModal={() => {
                setModal3(false);
                setCode("");
                setEmail("");
                setEmail("");
                setFirsName("");
                setLastName("");
                setMetrics([]);
                setPhoneNo("");
                setStep3(0);
              }}
            >
              <div>
                <img src={checked} alt="" />
                <h3>Changes saved</h3>
              </div>
              <p style={{ margin: "30px 0" }}>
                Admin has been successfully edited.
              </p>
            </AppModal>
          )}
        </div>
      )}
    </DashboardLayout>
  );
}
/* 
const Addnew = styled.div`
  background-color: #fff;
  gap: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  align-items: center;
  border: 1px solid #00b3fe;
  border-style: dashed;
  border-radius: 10px;
  cursor: pointer;

  p {
    text-align: center;
    font-size: 13px;
  }
  img {
    width: 100px;
  }
`;
const GridOut = styled.div`
  display: flex;
`;
 */
const ListedMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  flex-direction: column;
  margin-bottom: 20px;

  .list {
    padding: 6px;
    border-radius: 6px;
    background: #d3d3d3;
    color: #000000;
    margin-right: 6px;
    margin-bottom: 8px;
  }
`;
